import { Page } from "containers/Page";
import { useState } from "react";
import { LoteBloqueioAdministrativo } from "./features/Lote";
import { DetalhesLoteBloqueioAdministrativo } from "./features/DetalhesLote";
import { IDadosCriarLote } from "./interfaces/IDadosCriarLote";
import { defaultDadosCriarLote } from "./constants/defaultDadosCriarLote";
import { CriarLote } from "./features/CriarLote";
import { IPlanilhaCriarLote } from "./interfaces/IPlanilhaCriarLote";
import { ItensLoteBloqueioAdministrativo } from "./features/ItensLote";
import { useEmpresas } from "hooks/useEmpresas";

export function BloqueioAdministrativo() {
  const [pagina, setPagina] = useState<"LOTES" | "DETALHE" | "CRIAR" | "ITENS">(
    "ITENS",
  );
  const [loteEscolhido, setLoteEscolhido] = useState<null | number>(null);
  const [dadosCriarLote, setDadosCriarLote] = useState<IDadosCriarLote>(
    defaultDadosCriarLote,
  );
  const [dadosPlanilhaCriarLote, setDadosPlanilhaCriarLote] = useState<
    IPlanilhaCriarLote[]
  >([]);
  const { empresasOptions, listarCnpjsIntegracaoFrotista, cnpjsOptions } =
    useEmpresas(true);

  return (
    <Page title="Bloqueio Intenção de Venda">
      {pagina === "LOTES" && (
        <LoteBloqueioAdministrativo
          setPagina={setPagina}
          setLoteEscolhido={setLoteEscolhido}
          dadosCriarLote={dadosCriarLote}
          setDadosCriarLote={setDadosCriarLote}
          setDadosPlanilhaCriarLote={setDadosPlanilhaCriarLote}
          empresasOptions={empresasOptions}
          cnpjsOptions={cnpjsOptions}
          listarCnpjsIntegracaoFrotista={listarCnpjsIntegracaoFrotista}
        />
      )}
      {pagina === "DETALHE" && (
        <DetalhesLoteBloqueioAdministrativo
          setPagina={setPagina}
          loteEscolhido={loteEscolhido}
        />
      )}
      {pagina === "CRIAR" && (
        <CriarLote
          dadosCriarLote={dadosCriarLote}
          setDadosCriarLote={setDadosCriarLote}
          dadosPlanilhaCriarLote={dadosPlanilhaCriarLote}
          setDadosPlanilhaCriarLote={setDadosPlanilhaCriarLote}
          empresasOptions={empresasOptions}
          cnpjsOptions={cnpjsOptions}
          listarCnpjsIntegracaoFrotista={listarCnpjsIntegracaoFrotista}
        />
      )}
      {pagina === "ITENS" && (
        <ItensLoteBloqueioAdministrativo
          setPagina={setPagina}
          dadosCriarLote={dadosCriarLote}
          setDadosCriarLote={setDadosCriarLote}
          setDadosPlanilhaCriarLote={setDadosPlanilhaCriarLote}
          empresasOptions={empresasOptions}
          cnpjsOptions={cnpjsOptions}
          listarCnpjsIntegracaoFrotista={listarCnpjsIntegracaoFrotista}
        />
      )}
    </Page>
  );
}
